// Services Australia's own attachment constraints (Invoices 1.2.0). Deliberately NOT added to
// ~constants/files.ts: validFileTypes there is shared with supplier-invoice uploads, and adding
// image/tiff to it would silently widen an unrelated upload path (TAV-2591).
export const SA_ATTACHMENT_MAX_SIZE_MB = 5;
export const SA_ATTACHMENT_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
export const SA_ATTACHMENT_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/tiff'];

// Values are the Services Australia enum (note PRESC, not PRESCRIPTION); `name` is the friendly
// display label shown in the type selector.
export const SA_ATTACHMENT_TYPE_OPTIONS = [
  { id: 'INVOICE', name: 'Invoice' },
  { id: 'PRESC', name: 'Prescription' },
  { id: 'QUOTE', name: 'Quote' },
  { id: 'RECEIPT', name: 'Receipt' },
  { id: 'OTHER', name: 'Other' },
] as const;
